import { App } from './game/app'

const stage = document.getElementById('stage')
const ui = document.getElementById('ui')

if (!stage || !ui) {
  throw new Error('missing #stage / #ui')
}

const app = new App(stage, ui)
void app.boot()

// Vite HMR: tear the whole app down rather than leaving a second WebGL context
// and a second RAF loop running behind the new one.
if (import.meta.hot) {
  import.meta.hot.dispose(() => app.dispose())
}
